// extracted by mini-css-extract-plugin
export default {"numeric":"VJNW3yrYLwCjY6UgPlPn"};